import { configureStore } from '@reduxjs/toolkit';
import {
  createTransform,
  persistReducer,
  persistStore,
  PersistConfig,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './RootReducer';
import type { ActiveOrganisationState } from './slices/ActiveOrganisationSlice';

const activeOrganisationTransform = createTransform<
  ActiveOrganisationState,
  ActiveOrganisationState
>(
  (state) => state,
  (state) => ({
    ...state,
    isSwitchingOrganisation: false,
  }),
  { whitelist: ['activeOrganisationReducer'] }
);

const persistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
  key: 'root',
  storage,
  whitelist: ['activeOrganisationReducer'],
  transforms: [activeOrganisationTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER',
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
